export const getAvailableLocations = (user, allLocations) => {
  if (!user || !allLocations) return [];

  const isAdmin = [1, 3].includes(user?.role);
  const userLocationIds = user.locations?.map(({ id }) => id) || [];

  return allLocations.filter(({ id }) => (isAdmin ? true : userLocationIds.includes(id)));
};
